import ValueInterface, { SerializedValueType } from "./ValueInterface"

export const signs: string[] = ["÷", "/", ":"]

export type DivisionSign = (typeof signs)[number]

export default class DivisionValue implements ValueInterface {
  constructor(
    private readonly dividend: ValueInterface,
    private readonly sign: DivisionSign,
    private readonly divisor: ValueInterface,
  ) {
    if (this.divisor.normalize() === 0) {
      throw new Error("Division by zero.")
    }
  }

  public toString(): string {
    return `${this.dividend.toString()} ${this.sign} ${this.divisor.toString()}`
  }

  public normalize(): number {
    return this.dividend.normalize() / this.divisor.normalize()
  }

  public clone(): DivisionValue {
    return new DivisionValue(
      this.dividend.clone(),
      this.sign,
      this.divisor.clone(),
    )
  }

  public toJSON(): SerializedValueType {
    return {
      type: "division",
      payload: {
        dividend: this.dividend.toJSON(),
        sign: this.sign,
        divisor: this.divisor.toJSON(),
      },
    }
  }
}
